import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { useNavigationHooks } from "..";
import { useDealActions, useDealIdSelector } from "../../store";
import { INotification, UrlQueryParams } from "../../store/types";
import { JSON_to_URLEncoded } from "../../utils/json-to-url-encoded";
import { NotificationHandlerType } from "./use-click-handler";

export function useFormHook(): NotificationHandlerType {
  const { push } = useHistory();
  const currentDealId: number | undefined = useDealIdSelector();
  const { getDealAndStoreAction } = useDealActions();
  const { getFormPathName } = useNavigationHooks();

  return useCallback(async ({ components }: INotification) => {
    if (!components.form_id) return;

    const searchObj: UrlQueryParams = {};
    if (currentDealId == components.deal_id) {
      await getDealAndStoreAction(components.deal_id);
    }
    //added components.type === "submitted" and ?? components.section_id for opening crunchbase notifications
    if (
      components.type === "shared" ||
      components.type === "submitted" ||
      components.type === "finished" ||
      components.type === "failed"
    ) {
      searchObj.section = components.target_section_id ?? components.section_id;
      push({
        pathname: getFormPathName(components.deal_id, components.form_id),
        search: JSON_to_URLEncoded(searchObj)
      });
    }
  }, []);
}
